export const PREDICTION_OUTCOMES_PER_PAGE = {
  compact: 1,
  normal: 5,
} as const;

export function getPredictionOutcomesPerPage(isCompact: boolean): number {
  return isCompact ? PREDICTION_OUTCOMES_PER_PAGE.compact : PREDICTION_OUTCOMES_PER_PAGE.normal;
}

export function getPredictionOutcomePageCount(rowCount: number, isCompact: boolean): number {
  if (rowCount === 0) {
    return 0;
  }
  return Math.ceil(rowCount / getPredictionOutcomesPerPage(isCompact));
}

export function getPredictionOutcomePageRows<T>(rows: T[], pageIndex: number, isCompact: boolean): T[] {
  const perPage = getPredictionOutcomesPerPage(isCompact);
  const start = pageIndex * perPage;
  return rows.slice(start, start + perPage);
}

export function shouldPaginatePredictionOutcomes(rowCount: number, isCompact: boolean): boolean {
  return rowCount > getPredictionOutcomesPerPage(isCompact);
}

export function getBoundedPredictionOutcomePageIndex(activePageIndex: number | undefined, pageCount: number): number {
  const lastPageIndex = Math.max(pageCount - 1, 0);
  return Math.min(Math.max(activePageIndex ?? 0, 0), lastPageIndex);
}
